// src/VegetarianFood.tsx
import { createIcon } from "@chakra-ui/icon";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
var VegetarianFood_default = createIcon({
  displayName: "VegetarianFood",
  viewBox: "0 0 24 24",
  path: /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("rect", { opacity: "0", width: "24", height: "24", fill: "white", fillOpacity: "0" }),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M13 2C12.45 2 12 2.45 12 3C12 3.33 12.1702 3.59906 12.4102 3.78906C11.9802 4.63906 11.4709 5.83039 11.2109 7.15039C12.1309 7.34039 13.0091 7.72906 13.7891 8.28906C15.8291 9.74906 17 12.19 17 15C17 17.39 15.8794 19.54 14.1094 21H19C20.1 21 21 20.1 21 19V9C21 6.99 20.2198 5.02906 19.5898 3.78906C19.8298 3.59906 20 3.33 20 3C20 2.45 19.55 2 19 2H13ZM6.96289 5.98818C6.5922 5.99913 6.258 6.2143 6.09461 6.54722C5.93122 6.88014 5.96547 7.27615 6.18359 7.57607C6.44984 7.9537 6.70257 8.44676 6.85547 9.01552C5.94923 9.07474 5.07646 9.38271 4.32422 9.92763C2.84722 10.9966 2 12.842 2 14.994C2 18.305 4.916 20.9999 8.5 20.9999C12.084 20.9999 15 18.305 15 14.994C15 12.844 14.135 10.992 12.627 9.91201C11.5395 9.13387 10.2231 8.85262 8.92188 9.08779C8.74275 7.97217 8.2683 7.06468 7.81641 6.42373C7.6245 6.14283 7.30296 5.97874 6.96289 5.98818Z",
        fillRule: "evenodd",
        clipRule: "evenodd",
        fill: "currentColor"
      }
    )
  ] })
});

export {
  VegetarianFood_default
};
